export default () => ({
  customer: {},
  items: [],
  pagination: [],
  item: {},
  updateProfile: false
})
